import { Refused } from "../net/api.ts";
import { say } from "./say.ts";

export function failureSaid(cause: unknown, fallback = say("failure.generic")): string {
  if (!(cause instanceof Refused)) return fallback;
  if (cause.status === 401) return say("failure.signedOut");
  if (cause.status === 403) return say("failure.notAllowed");
  if (cause.status === 404) return say("failure.notFound");
  if (cause.status === 409) return say("failure.conflict");
  if (cause.status >= 500) return say("failure.unconfigured");
  return fallback;
}
